import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import themeConfig from './theme.config';

void i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: themeConfig.locale || 'en',
        debug: true, // Activer le debug pour voir les erreurs
        load: 'languageOnly',
        // Désactiver la détection automatique pour utiliser la locale de Symfony
        initImmediate: false,
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json?v=' + Date.now(),
        },
        interpolation: {
            escapeValue: false,
        },
    });
export default i18n;
